import React, { useEffect, useState, useCallback, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';
import BarLoader from 'react-spinners/BarLoader';

import { faCirclePause, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';

/** service */
import { fileUpload } from '../../service/api';

const FileUploader = ({
  field,
  fieldValue,
  fieldError,
  handleSetData,
  handleSetDataError,
  handleSaveFileProperty,
  initializeSectionError,
  disabled,
  fileInputName,
  updateFileValue,
  handleRemoveItem,
}) => {
  const [fileSource, setFileSource] = useState();
  const [isUploading, setIsUploading] = useState(false);

  const isMultiUpload = field.subSection && field.limits.maximum > 1;
  const updatedFieldValue = useRef();

  useEffect(() => {
    updatedFieldValue.current = fieldValue;
  }, [fieldValue]);

  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (!!disabled) {
        return;
      }

      const fileNamePrefix = field.fileName ?? field.name;
      let maxIndex = 0;
      const currentItemCount = updatedFieldValue.current ? updatedFieldValue.current.length : 0;

      fieldValue.forEach((fileItem) => {
        const nameParts = fileItem?.fileName?.split('-');
        const index = nameParts[nameParts.length - 1];
        if (Number.parseInt(index) > maxIndex) {
          maxIndex = Number(index);
        }
      });

      const newItems = [];

      const filesArray = Array.from(acceptedFiles);

      if (isMultiUpload) {
        // Check the max_limit before uploading
        const newLength = filesArray.length + fieldValue.length;
        if (field.limits.maximum < newLength) {
          handleSetDataError(
            field,
            `The maximum number of files you can upload is ${
              field.limits.maximum - fieldValue.length
            }.`
          );
          return;
        }

        // Uploading files for category field
        filesArray.map((file, i) => {
          const fileName = fileNamePrefix + '-' + (maxIndex + i + 1);
          newItems.push({
            isNew: true,
            isUploading: true,
            fileType: field.fileType,
            isCanceled: false,
            fileName: fileName,
          });
        });

        handleSetData(field, [...fieldValue, ...newItems]);

        const promises = filesArray.map((file, i) => {
          const fileName = isMultiUpload
            ? fileNamePrefix + '-' + (maxIndex + i + 1)
            : fileNamePrefix;
          return uploadFileAction(file, null, fileName, fieldValue.length + i);
        });
        setIsUploading(true);
        const uploadRes = await Promise.allSettled(promises);
        /** TODO: check if we can improve the state management for file uploads */
        // for (let i = newItems.length - 1; i >= 0; i--) {
        //   if (!uploadRes[i].value) {
        //     console.log('remove item', currentItemCount + i);
        //     // Remove item of index (currentItemCount + i)
        //     // handleRemoveItem(currentItemCount + i);
        //   }
        // }
      } else {
        // Uploading files for non-category field : should replace the existing item
        updateFileValue(0, {
          isNew: true,
          isUploading: true,
          fileType: field.fileType,
          isCanceled: false,
        });
        setIsUploading(true);
        const uploadRes = await uploadFileAction(filesArray[0], null, fieldValue[0].fileName, 0);
        if (!uploadRes) {
          setIsUploading(false);
          return false;
        }
      }

      try {
        await handleSaveFileProperty();
      } catch (e) {
        console.log('error', e);
        handleSetDataError(
          field,
          'An unexpected error occurred while uploading this file. Please try again, if the error persists please contact support.'
        );
      }
      setIsUploading(false);
    },
    [fieldValue]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: isMultiUpload,
    disabled,
  });

  const uploadFileAction = async (file, fileItem, fileName, itemIdx) => {
    handleSetDataError(field, '');

    const source = axios.CancelToken.source();
    setFileSource(source);

    updateFileValue(itemIdx, {
      source: source,
      error: '',
    });
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fileUpload(formData, field.fileType, source.token);
      if (res && res.data) {
        updateFileValue(itemIdx, {
          isUploading: false,
          id: res.data.fileId,
          fileName: fileName,
          fileType: field.fileType,
          status: 'SUBMITTED',
          showMeta: '1',
          isProtected: '0',
          isPwdShow: '0',
          password: null,
          category: field.subSection,
        });
      }
      return true;
    } catch (e) {
      if (e.message == 'Operation canceled by the user.') {
      } else {
        let errorMsg = '';
        if (e?.response?.data?.errors[0]?.message == 'Request size exceeds limit: 20971520') {
          errorMsg = 'Upload failed, please make sure the file size does not exceed 20 MB';
        } else {
          errorMsg = 'An unexpected error occurred while uploading this file.';
        }
        updateFileValue(itemIdx, {
          isUploading: false,
          isCanceled: false,
          error: errorMsg,
        });
        handleSetDataError(
          field,
          'An unexpected error occurred while uploading this file. Please try again, if the error persists please contact support.'
        );
      }
      //   // Reset to previous state
      //   handleSetData(field, fieldValue);
    }
    return false;
  };

  return (
    <div className="file-upload-area">
      <div className={`drag-drop-section ${disabled ? 'disabled' : ''}`}>
        <div {...getRootProps({ className: 'drag-drop-file dropzone' })}>
          <label>
            <FontAwesomeIcon
              icon={faFileUpload}
              color={disabled ? '#A0A0A0' : '#413273'}
              fontSize={30}
            />
            <p className="drag-file">
              {isUploading ? 'Uploading...' : 'Drag and drop files or Browse'}
            </p>
          </label>
          <input {...getInputProps()} name={fileInputName} disabled={disabled} spellCheck={false} />
        </div>
      </div>
    </div>
  );
};

export default FileUploader;
